export var Step = /*#__PURE__*/ function(Step) {
    Step["First"] = "first";
    Step["Second"] = "second";
    Step["QBO"] = "qbo";
    Step["QBOSetup"] = "qboSetup";
    Step["Saving"] = "Saving";
    return Step;
}({});
export var ErrorType = /*#__PURE__*/ function(ErrorType) {
    ErrorType["General"] = "general";
    ErrorType["Stripe"] = "stripe";
    return ErrorType;
}({});
